"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Severity_1 = require("../shared/Severity");
class ValidationFailure {
    constructor(target, propertyName, attemptedValue, code, message, severity = Severity_1.Severity.ERROR) {
        this.target = target;
        this.propertyName = propertyName;
        this.attemptedValue = attemptedValue;
        this.code = code;
        this.message = message;
        this.severity = Severity_1.Severity[severity];
    }
}
exports.ValidationFailure = ValidationFailure;
//# sourceMappingURL=ValidationFailure.js.map